import * as React from 'react';
import AbsentSvg from './absent.svg';
import AttendSvg from './attend.svg';
import classNames from 'classnames';
import './attendanceButton.module.scss';

type Props = {
  value: boolean;
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange: (nextValue: boolean) => any;
};

export class AttendanceButton extends React.Component<Props> {
  render() {
    const { value, disabled = false, onChange } = this.props;
    const active = !disabled && value;
    return (
      <div styleName={classNames('attendance-button', { active: active })} onClick={() => onChange(!value)}>
        {active && <img styleName="icon" src={AttendSvg} />}
        {!active && <img styleName="icon" src={AbsentSvg} />}
        <span styleName="label">{disabled ? '確定済' : value ? '出席' : '欠席'}</span>
      </div>
    );
  }
}
